module.exports = __webpack_public_path__ + "static/img/star-small.a9b7167a.png";